'use strict';

export default {
    namespaced: true,
    state: {
        errors: {},
        isBusy: true
    },
    getters: {
        errors: (state) => state.errors,
        isBusy: (state) => state.isBusy
    },
    mutations: {
        SET_ERRORS(state, value) {
            Object.entries(value).forEach((val) => {
                const key = val[0];
                const arr = val[1];

                value[key] = arr.join(' ');
            });

            state.errors = value;
        },
        SET_ERRORS_EMPTY(state) {
            state.errors = {};
        },
        SET_IS_BUSY(state, value) {
            state.isBusy = value;
        }
    },
    actions: {}
};
